/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const IosShare = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M11.25 5.26733L8.06066 8.53034L7 7.46968L10.9393 3.43934C11.5251 2.85355 12.4749 2.85355 13.0607 3.43934L17 7.46968L15.9393 8.53034L12.75 5.26732V16H11.25V5.26733Z"
                        fill={color}
                    />
                    <path
                        d="M3 11H4.5V19.5H19.5V11H21V19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5V11Z"
                        fill={color}
                    />
                </svg>
        );
    };
